import { IBudgetVersionService, IBudgetVersionServiceItem } from "../../../../models/budgetV2";

export const createEmptyBudgetVersionServiceItem = (
  ref = "1.01"
): IBudgetVersionServiceItem => ({
  id: `temp-item-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  ref,
  item: "",
  description: "",
  quantity: 1,
  value: 0,
  discount: 0,
  subtotal: 0,
  isCovered: false,
});

export const createEmptyBudgetVersionService = (): IBudgetVersionService => ({
  id: "",
  ref: "",
  name: "",
  service: "",
  serviceType: undefined,
  description: "",
  items: [],
  serviceItems: [],
  percentages: {
    customer: 100,
    volkstok: 0,
    dealership: 0,
    warranty: 0,
  },
  observation: "",
  subtotal: 0,
  discount: 0,
  isExternalService: false,
});

